export const OFFICE = {
  line1: "Al Dakhal Al Mahdud Subdivision",
  line2: "Al Jubail 35513, Saudi Arabia",
  full: "Al Dakhal Al Mahdud Subdivision, Al Jubail 35513, Saudi Arabia",
};

const q = encodeURIComponent(OFFICE.full);
export const OFFICE_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${q}`;
export const OFFICE_EMBED_URL = `https://www.google.com/maps?q=${q}&output=embed&z=14`;
